import { useLayoutEffect, useRef, useCallback } from "react";
import { useProjectUIStore, useProjectDataStore } from "stores/projectStore";

export const useRedraw = () => {
  const treeRef = useProjectDataStore((state) => state.treeRef);
  const projectTree = useProjectDataStore((state) => state.projectTree);
  const showProductPictures = useProjectUIStore(
    (state) => state.showProductPictures,
  );
  const redrawIndex = useRef(0);
  const setRedrawIndex = useCallback((index) => {
    redrawIndex.current = index;
  }, []);

  // This layout effect is used to redraw the list when the project tree is updated.
  useLayoutEffect(() => {
    const treeApi = treeRef?.current;
    // Redraw logic
    if (!treeApi) {
      return;
    }
    treeApi.redrawList(redrawIndex.current);
    setRedrawIndex(0);
  }, [projectTree, setRedrawIndex, treeRef, showProductPictures]);

  return {
    setRedrawIndex,
  };
};
